import { Button } from '@optools/components/ui/button';
import { Card, CardHeader, CardTitle } from '@optools/components/ui/card';
import { CircleX } from 'lucide-react';

export interface PlayerCardProps {
  cardContent: React.ReactNode;
  label: string;
  onRemovePlayer: () => void;
}

export function PlayerCard({ cardContent, label, onRemovePlayer }: PlayerCardProps) {
  return (
    <Card className="flex w-200 flex-col p-1" data-testid="player-card">
      <CardHeader className="flex justify-between p-0">
        <CardTitle className="pl-2">{label}</CardTitle>
        <Button
          aria-label="Remove player"
          className="self-end"
          size="icon-sm"
          variant="ghost"
          onClick={onRemovePlayer}>
          <CircleX />
        </Button>
      </CardHeader>
      {cardContent}
    </Card>
  );
}
